var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 60.5C0 27.3629 26.8629 0.5 60 0.5C93.1371 0.5 120 27.3629 120 60.5C120 93.6371 93.1371 120.5 60 120.5C26.8629 120.5 0 93.6371 0 60.5Z",
    fill: "#F1F5F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.443 52.2904C65.443 50.8469 64.8696 49.4625 63.8489 48.4418C62.8282 47.4211 61.4438 46.8477 60.0003 46.8477C58.5568 46.8477 57.1725 47.4211 56.1517 48.4418C55.131 49.4625 54.5576 50.8469 54.5576 52.2904C54.5576 53.7339 55.131 55.1182 56.1517 56.1389C57.1725 57.1596 58.5568 57.7331 60.0003 57.7331C61.4438 57.7331 62.8282 57.1596 63.8489 56.1389C64.8696 55.1182 65.443 53.7339 65.443 52.2904ZM51.292 52.2904C51.292 49.9808 52.2095 47.7658 53.8426 46.1326C55.4757 44.4995 57.6907 43.582 60.0003 43.582C62.3099 43.582 64.5249 44.4995 66.158 46.1326C67.7912 47.7658 68.7087 49.9808 68.7087 52.2904C68.7087 54.6 67.7912 56.815 66.158 58.4481C64.5249 60.0812 62.3099 60.9987 60.0003 60.9987C57.6907 60.9987 55.4757 60.0812 53.8426 58.4481C52.2095 56.815 51.292 54.6 51.292 52.2904ZM48.1148 75.1497H71.8858C71.2803 70.8432 67.5793 67.5299 63.1095 67.5299H56.8912C52.4214 67.5299 48.7203 70.8432 48.1148 75.1497ZM44.7607 76.3948C44.7607 69.6934 50.1898 64.2643 56.8912 64.2643H63.1095C69.8108 64.2643 75.2399 69.6934 75.2399 76.3948C75.2399 77.5105 74.3351 78.4154 73.2193 78.4154H46.7813C45.6656 78.4154 44.7607 77.5105 44.7607 76.3948Z",
    fill: "#526077"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.999968ae.svg";
export { ForwardRef as ReactComponent };